<template>
    <v-dialog :class="isMobile ? 'mobile-modal' : 'normal-modal'" style="overflow-y: hidden;" v-model="dialogControl">
        <v-card class="dialog-card" style="border-radius: 10px;">
            <v-flex id="attachArea" class="inner-card-flex">
                <div style="position: absolute; top: 5; left: 5; display: flex; justify-content: start;">
                    <site-button btnType="text" :margin-number="0" :colNum="showSeo ? 12 : 9" @click-event="toggleSeo"
                        :colorClasses="showSeo ? 'secondary-icon builder-toggle-outline' : 'info-icon builder-toggle-outline'"
                        :toolTipClasses="showSeo ? 'secondary-tooltip' : 'info-tooltip'"
                        :toolTip="showSeo ? 'Page Builder' : 'SEO Configuration'" tool-tip-gravity="BOTTOM"
                        :icon-type="showSeo ? 'ICON' : 'SVG'"
                        :iconString="showSeo ? 'fas fa-screwdriver-wrench' : seoImg"></site-button>
                </div>
                <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
                <v-menu fixed attach="#attachArea" :close-on-content-click="false" v-model="showCloseConfirm"
                    content-class="confirm-popup">
                    <v-card style="height: 100%; width: 100%;">
                        <v-card-text>
                            <v-row>
                                <span>You have unsaved changes. Do you want to save first?</span>
                            </v-row>
                            <v-row style="margin-top: auto;">
                                <v-col>
                                    <v-btn @click="close" text>Close</v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn class="success-text-btn" @click="saveChanges" text>Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-menu>
                <v-container v-if="!showSeo">
                    <v-row style="margin-bottom: auto;" dense>
                        <v-col>
                            <h2>Page Builder</h2>
                        </v-col>
                    </v-row>
                    <v-row class="end mb-4" dense>
                        <v-col>
                            <h2>
                                Image Carousel
                                <v-tooltip content-class="info-tooltip"
                                    v-if="carouselSelect != null || carouselImages.length" top :open-on-hover="true">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="info-icon" v-bind="attrs" v-on="on">fas fa-circle-info</v-icon>
                                    </template>
                                    <span v-if="carouselSelect != null">(Back To Carousel)</span>
                                    <span v-else-if="carouselImages.length && carouselSelect == null">(Click Image To
                                        Edit)</span>
                                </v-tooltip>
                            </h2>
                            <photo-carousel @remove-image="removeCarouselImage" @select-image="selectCarouselImage"
                                @replace-image="replaceCarouselImage" @change-link-type="changeLinkType"
                                @change-link="changeLink" :editingIndex="carouselSelect" :images="carouselImages"
                                :editable="true" :maxHeight="200" />
                            <site-button v-if="carouselImages.length < 10" btnType="text" :colNum="11"
                                @click-event="selectNewCarouselImage" colorClasses="mt-5 success-icon"
                                toolTipClasses="success-tooltip" toolTip="Add Carousel Image"
                                iconString="far fa-plus-square"></site-button>
                            <input multiple ref="carousel-image-add" style="display: none;" type="file" accept="image/*"
                                @change="addCarouselImages($event)" />
                        </v-col>
                        <v-col style="margin-bottom: auto;" cols="6">
                            <v-row class="mb-6 mr-6 end">
                                <h4 class="mr-6">Page Visibility:</h4>
                                <v-btn-toggle :background-color="page.published ? 'success-icon' : 'secondary-icon'"
                                    v-model="page.published" @change="publishedChanged" mandatory>
                                    <v-btn :value="true">Publish</v-btn>
                                    <v-btn :value="false">Unpublish</v-btn>
                                </v-btn-toggle>
                            </v-row>
                            <v-container>
                                <h2>Select Page Widgets</h2>
                                <v-data-table :headers="widgetHeaders" :items="navItems" :hide-default-footer="true"
                                    class="elevation-1 widget-table">
                                    <template v-slot:item="{ item, index }">
                                        <tr>
                                            <td>{{ item.label }}</td>
                                            <td>
                                                <v-icon class="secondary-icon" size="medium"
                                                    @click="deleteNavItem(index)">fas fa-trash</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer>
                                        <site-button v-if="!selectWidget" btnType="text" :colNum="11"
                                            @click-event="selectWidget = true" toolTip="Add Widget"
                                            iconString="far fa-plus-square"></site-button>
                                        <v-row v-else>
                                            <v-col cols="10">
                                                <v-select v-model="newWidgetSelect" :rules="widgetRules" color="#00006d"
                                                    item-text="title" item-value="value" :items="widgetTypes"
                                                    @change="selectNewWidget" label="Widget Type" return-object
                                                    outlined></v-select>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-icon style="font-size: 20pt; margin-top: 0.5em;"
                                                    @click="closeNewWidget">fas fa-times</v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="5">
                            <h2>Announcement</h2>
                        </v-col>
                        <v-col></v-col>
                        <v-col cols="5"></v-col>
                    </v-row>
                    <v-row class="center" dense>
                        <v-col cols="5">
                            <v-text-field v-model="announcementInput.title" label="Title" outlined></v-text-field>
                            <v-textarea v-model="announcementInput.text" outlined label="Announcement"></v-textarea>
                        </v-col>
                        <v-col></v-col>
                        <v-col style="margin-bottom: auto;" cols="6">
                            <color-picker-carousel v-if="homePageTheme" @color-change="changeThemeColor"
                                :theme="homePageTheme" />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-list>
                                <template>
                                    <v-list-item v-for="(item, index) in page.posts" :key="index"
                                        style="margin: 1.25em 0px;">
                                        <post-list-item editable :propPost="item" :isNew="item.isNew" :key="index"
                                            :index="index" @update-post="updatePost"
                                            @delete-post="removePost"></post-list-item>
                                    </v-list-item>
                                </template>
                            </v-list>
                            <site-button @click-event="addNewPost" btnType="text" :colNum="11" toolTip="Add New Post"
                                iconString="far fa-plus-square"></site-button>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container class="px-12" v-else>
                    <v-row class="mb-4" style="margin-bottom: auto;" dense>
                        <v-col>
                            <h2>SEO Configuration</h2>
                        </v-col>
                    </v-row>
                    <v-row class="center page-seo-area mx-2">
                        <v-col cols="10"><h3>Page SEO</h3></v-col>
                        <v-col md="5" sm="6" cols="10">
                            <v-text-field v-model="seo.siteTitle" @input="changingInput" label="Search Engine Title" outlined></v-text-field>
                            <v-textarea v-model="seo.description" @input="changingInput" outlined label="Search Engine Description"></v-textarea>
                        </v-col>
                        <v-col md="5" sm="6" cols="10" style="margin-bottom: auto;">
                            <v-text-field v-model="seo.tabTitle" @input="changingInput" label="Tab Title" outlined></v-text-field>
                            <v-col sm="9" cols="10" class="center">
                                <upload-area @file-upload="setFavicon" :img="favIconImg" id="faviconImg" label="Browser Favicon" />
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row class="center">
                        <v-col cols="10">
                            <search-tag-row label="SEO Keywords" :business-search-tags="seo.keywords" @add-tag="addSearchString"
                                @delete-tag="deleteSearchString" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-flex>
            <v-tooltip v-if="hasChanges" top :open-on-hover="true">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="saveChanges" class="submit-fab" absolute v-bind="attrs" v-on="on" fab>
                        <v-icon class="primary-icon" style="font-size: 3em;">fa-solid fa-circle-check</v-icon>
                    </v-btn>
                </template>
                <span>Submit</span>
            </v-tooltip>
        </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>
.modal-card {
    width: 65% !important;
    max-width: 65%;
}

.submit-fab {
    bottom: 2em;
    right: 2em;
}

.confirm-popup {
    width: 275px;
    height: 140px;
    left: unset !important;
    top: 1em !important;
    right: 10px !important;
}

.widget-table {
    margin: 2em auto 2em auto;

    tr {
        td {
            text-align: left;
        }
    }
}

::v-deep .v-dialog {
    overflow-y: hidden !important;
    border-radius: 15px;
    height: 90%;
    max-height: 90% !important;
    max-width: 90%;
}

.dialog-card {
    height: 100%;
    overflow-y: hidden;
    position: relative;
}

.inner-card-flex {
    height: 100%;
    overflow-y: auto;
    margin-left: 0;
    margin-right: 0;
}
</style>

<script>
import ColorCarousel from '../common/ColorCarousel';
import SiteButton from '../common/SiteButton';
import PostList from '../common/PostListItem';
import WidgetTypes from '../../assets/Enums/WidgetTypeEnums';
import PhotoCarousel from './PhotoCarousel';
import UploadArea from './UploadArea';
import SearchTagRow from './TagSelect';
import FileType from '../../assets/Enums/FileType';
import SeoImg from '../../assets/Configure-SEO.svg';
import { MongoMixins } from '../../mixins/mongo-mixins';
import moment from 'moment';

export default {
    name: 'site-builder-dialog',
    mixins: [MongoMixins],
    components: {
        'site-button': SiteButton,
        'post-list-item': PostList,
        'photo-carousel': PhotoCarousel,
        'color-picker-carousel': ColorCarousel,
        'search-tag-row': SearchTagRow,
        'upload-area': UploadArea
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        pageData: {
            type: Object,
            default: () => { },
        },
        navItems: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        page: null,
        initialPageData: null,
        widgetHeaders: [
            { text: 'Widget', value: 'label' },
            { text: 'Actions', key: 'actions', sortable: false },
        ],
        newImages: [],
        removedImages: [],
        announcementInput: {
            title: '',
            text: '',
        },
        seo: {
            tabTitle: '',
            siteTitle: '',
            description: '',
            favIconImg: null,
            keywords: []
        },
        selectWidget: false,
        newWidgetSelect: null,
        carouselSelect: null,
        hasChanges: false,
        showCloseConfirm: false,
        showSeo: false,
        favIconFile: null
    }),
    created() {
        console.log('setup ', this.pageData);
        this.page = this.pageData;
        this.initialPageData = this.pageData;
        if (this.pageData.announcement) this.announcementInput = this.pageData.announcement;
        if (this.pageData.seo) this.seo = this.pageData.seo;
    },
    // updated() {
    //     console.log('updated ', this.pageData)
    //     this.hasChanges = true;
    // },
    methods: {
        changingInput() {
            this.hasChanges = true;
        },
        toggleSeo() {
            this.showSeo = !this.showSeo;
        },
        setFavicon(file) {
            this.hasChanges = true;
            this.favIconFile = file;
        },
        addSearchString(searchString) {
            console.log('add search string');
            this.hasChanges = true;
            this.seo.keywords.push(searchString.toString());
        },
        deleteSearchString(index) {
            console.log('delete at ' + index);
            this.hasChanges = true;
            this.seo.keywords.splice(index, 1);
        },
        close() {
            this.page = this.initialPageData;
            this.hasChanges = false;
            this.dialogControl = false;
            this.showCloseConfirm = false;
        },
        changeLink(id, i, link) {
            this.hasChanges = true
            console.log('ID: ' + id, ' INDEX: ' + i)
            const carouselLength = this.page.carouselImages.length

            if (id) this.page.carouselImages[i].link = link
            else {
                if (this.page.carouselImages.length > 0) this.newImages[carouselLength - i].link = link
                else this.newImages[carouselLength + i].link = link
            }
        },
        changeLinkType(id, i, type) {
            this.hasChanges = true
            console.log('ID: ' + id, ' INDEX: ' + i)
            const carouselLength = this.page.carouselImages.length

            if (id) this.page.carouselImages[i].linkType = type
            else {
                if (this.page.carouselImages.length > 0) this.newImages[carouselLength - i].linkType = type
                else this.newImages[carouselLength + i].linkType = type
            }
        },
        publishedChanged() {
            this.hasChanges = true;
        },
        changeThemeColor(theme) {
            this.hasChanges = true;
            console.log('change theme ', theme);

            this.$store.dispatch('UPDATE_THEME_ITEM', theme);
        },
        formatDate(date) {
            return moment(date).format('MM.DD.YYYY H a');
        },
        addNewPost() {
            this.hasChanges = true
            this.page.posts.push({
                title: '',
                paragraph: '',
                type: '',
                isNew: true,
                visible: true,
                createdAt: new Date(),
            });
        },
        updatePost(i, post) {
            this.hasChanges = true;
            console.log('index ' + i + ' post: ' + JSON.stringify(post));
            this.page.posts[i] = post;
        },
        removePost(i) {
            this.hasChanges = true;
            this.page.posts.splice(i, 1);
        },
        deleteNavItem(i) {
            this.hasChanges = true
            this.$emit('delete-nav-item', i)
        },
        closeNewWidget() {
            this.selectWidget = false
            this.newWidgetSelect = null
        },
        selectNewCarouselImage() {
            this.$refs['carousel-image-add'].click()
        },
        addCarouselImages($event) {
            const files = $event.target.files;
            const existingLength = this.page?.carouselImages?.length || 0;

            for (const file of files) {
                const url = URL.createObjectURL(file)
                console.log('caro image: ' + file.name)
                this.newImages.push({
                    index: existingLength + this.newImages.length,
                    src: url,
                    linkType: null,
                    link: null,
                    photo: { photoData: url, photoFile: file, type: FileType.BUSINESS },
                })
            }
        },
        removeCarouselImage(id, index) {
            this.hasChanges = true
            const imageIndex = this.page?.carouselImages?.findIndex(i => i._id === id) || -1,
                carouselLength = this.page?.carouselImages?.length || 0;

            console.log('remove ' + imageIndex + ' passed index ' + index + ' length ' + carouselLength)

            if (imageIndex > -1) {
                this.page.carouselImages.splice(imageIndex, 1)
                this.removedImages.push(id)
            } else {
                console.log('splice image ' + carouselLength - index)
                if (carouselLength > 0) this.newImages.splice(carouselLength - index, 1)
                else this.newImages.splice(carouselLength + index, 1)
            }
            this.carouselSelect = null
        },
        replaceCarouselImage(id, file, index) {
            this.hasChanges = true
            console.log('ID: ' + id, ' INDEX: ' + index)
            const carouselLength = this.page?.carouselImages?.length || 0,
                item = file.target.files[0],
                url = URL.createObjectURL(file),
                newImg = {
                    index: carouselLength,
                    src: url,
                    photo: { photoData: url, photoFile: item, type: FileType.BUSINESS },
                }

            console.log('caro image: ' + item.name)
            if (id) this.page.carouselImages.slice(index, 1, newImg)
            else {
                if (carouselLength > 0) this.newImages.splice(carouselLength - index, 1)
                else this.newImages.splice(carouselLength + index, 1)
            }
        },
        selectCarouselImage(i) {
            this.carouselSelect = i
        },
        async saveChanges() {
            if(this.favIconFile) {
                const photo = await this.submitPhoto(this.$store.getters.partnerId, this.favIconFile, FileType.FAVICON);
                this.seo.favIconImg = photo.data.pid;
            }
            this.hasChanges = false
            this.dialogControl = false
            console.log(this.announcementInput);
            this.page.announcement = this.announcementInput;
            this.page.seo = this.seo;
            this.$emit('update-page-data', this.page, this.newImages, this.removedImages)
            this.newImages = []
        },
        selectNewWidget(type) {
            this.hasChanges = true
            console.log(type)
            if (!this.navItems.find(s => s.widget == type.value)) {
                this.$emit('add-nav-item', { label: type.title, widget: type.value, type: 'WIDGET' })
                this.selectWidget = false
                this.newWidgetSelect = null
            }
        },
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                console.log('has changes ' + this.hasChanges)
                if (this.hasChanges) {
                    this.showCloseConfirm = true
                } else {
                    this.$emit('set-dialog-control', newVal)
                }
            },
        },
        isMobile() {
            return screen.width <= 760
        },
        widgetTypes() {
            return [
                { title: 'Daily Deals', value: WidgetTypes.DAILY_DEALS },
                { title: 'Group Deals', value: WidgetTypes.GROUP_DEALS },
                { title: 'Menu', value: WidgetTypes.MENU }
            ]
        },
        widgetRules() {
            return [
                v => !v.widget || 'Select Widget',
                v => (!!v.widget && !this.navItems.find(i => i.widget == v.value)) || 'Widget Already Enabled',
            ]
        },
        carouselImages() {
            return [...(this.page && this.page.carouselImages ? this.page.carouselImages : []), ...this.newImages]
        },
        homePageTheme() {
            return this.$store.state.homePage ? this.$store.state.homePage.theme : null
        },
        seoImg() {
            return SeoImg;
        },
        favIconImg() {
            return this.seo.favIconImg ? `${process.env.VUE_APP_BUS_API_URL}/image-host?pid=${this.seo.favIconImg}` : null;
        }
    },
}
</script>
